const PATHS = {
	BASE: '/',
	ALL_ROUTES: '/*',
	LOGIN: '/login',
	REGISTER: '/register',
	REGISTER_WITH_PROVIDER: '/register-with-provider',
	TERMS_AND_CONDITIONS: '/terms-and-conditions',
	RESET_PASSWORD: '/change-password',
	FORGOT_PASSWORD: '/forgot-password',
	SHIPMENT_TRACKING: '/shipment-tracking',
	OTOFLEX_TRACKING: '/otoflex-tracking',
	LOGOUT: '/logout',
	SMS: '/sms/*',
	ACCESS_CONTROL: '/access-control',
	ENUM_MANAGEMENT: '/enum-management',
	CLIENT_LISTING: '/client-listing',
	PACKAGES: '/packages',
	PACKAGES_LIST: 'packages-list',
	MODULES: 'modules',
	SUBSCRIPTION: '/subscription',
	SUBSCRIPTION_LISTING: 'subscription-list',
	SUBSCRIPTION_TRANSACTIONS_LISTING: 'subscription-transactions',
	COHORT_ANALYSIS: '/cohort-analysis',
	COHORT_AGGREGATOR_ANALYSIS: 'aggregator',
	COHORT_AGGREGATOR_DISTRIBUTION: 'aggregator-distribution',
	COHORT_INTEGRATOR_ANALYSIS: 'integrator',
	COHORT_INTEGRATOR_DISTRIBUTION: 'integrator-distribution',
	ERROR: '/error',
	HOME: '/home',
	SALES_CHANNELS: '/sales-channels',
	ONLINE_STORES: 'online-stores',
	CONNECTED_STORES: 'connected-stores',
	SALES_CHANNELS_DETAILS: '/sales-channels/:slug',
	ADMIN_SALES_CHANNELS: '/admin/sales-channels',
	API_INTEGRATIONS: '/api-integrations',
	OTO_API: 'oto-api',
	CONNECTED_TOKENS: 'api-tokens',
	ANALYSIS: '/analysis',
	ANALYSIS_TAB: 'overview',
	SLA_PERFORMANCE: 'sla-performance',
	DELIVERY_COMPANY: 'delivery-company',
	SHIPPING_ACCOUNTING: 'shipping-accounting',
	SALES: 'sales',
	CUSTOMER_DETAILS: 'customer-details',
	OTO_FLEX: 'oto-flex',
	OTO_FLEX_MAIN: '/oto-flex',
	OTO_LINK: '/oto-link',
	OTO_LINK_BUYER: '/oto-link/buyer',
	ALL_LINKS: 'all',
	ACTIVE_LINKS: 'active',
	ORDERS: 'orders',
	OTO_STORE: '/oto-store',
	OTO_STORE_CHECKOUT: '/oto-store/checkout',
	OTO_STORE_MY_ORDERS: '/oto-store/my-orders',
	OTO_STORE_PRODUCT: '/oto-store/product',
	DRIVERS: '/drivers',
	UNASSIGNED_ORDERS: 'unassigned-orders',
	PROCESSING_ORDERS_SUB: 'processing-orders',
	HISTORY_ORDERS_SUB: 'history-orders',
	PRICE_CALCULATOR: '/price-calculator',
	SHIPMENTS: '/shipments',
	PENDING_ORDERS: 'pending-orders',
	AWAITING_PICKUP: 'awaiting-pickup',
	CURRENTLY_SHIPPING: 'currently-shipping',
	ONHOLD_ORDERS: 'onhold-orders',
	RETURNED_ORDERS: 'returned-orders',
	CANCELED_ORDERS: 'canceled-orders',
	ALL_ORDERS: 'all-orders',
	SHIPMENTS_PRICE_CALCULATOR: '/shipments/price-calculator',
	DELIVERED_ORDERS: 'delivered-orders',
	OPERATION_SHIPMENT: '/operation-shipment',
	OPERATION_ALL_ORDERS: 'operation-all-orders',
	OPERATION_NEED_ACTION_SHIPMENT: 'need-action-shipment',
	DASHBOARD: '/dashboard',
	UNIT_ECONOMICS_DASHBOARD: '/unit-economics-dashboard',
	COMPANY_KPI_DASHBOARD: '/company-kpi-dashboard',
	AGGREGATOR_DC_PERFORMANCE: '/dc-performance-dashboard',
	AGGREGATOR_AGING: '/aggregator-aging',
	AGGREGATOR_AGING_SHIPMENTS: 'shipments',
	AGGREGATOR_AGING_OVERVIEW: 'overview',
	AGGREGATOR_AGING_SUMMARY: 'summary',
	ZERO_DC_GROUPED: 'grouped-results',
	ZERO_DC: '/zero-dc',
	ZERO_DC_DETAILED: 'detailed-results',
	PROMOTIONS: '/promotions',
	PROMO_CODES: 'promo-codes',
	PROMO_TRANSACTIONS: 'promo-transactions',
	PRODUCTS_MAIN: '/products',
	PRODUCTS: 'products',
	PRODUCT_ATTRIBUTES: 'product-attributes',
	ATTRIBUTES_GROUPS: 'attributes-groups',
	BRANDS: '/brands',
	OTOFLEX_SETTINGS: '/otoflex-settings',
	OTOPACK_SETTINGS: '/otopack-settings',
	CONTENT_PREFERENCES: '/content-preferences',
	IMPORT_EXPORT: '/import-export',
	BOX_SETTINGS: '/box-settings',
	PICKUP_LOCATION: '/pickup-location',
	REASON: '/reason-config',
	REASON_CONFIG: 'reason-config',
	PREDEFINED_MESSAGES: 'predefined-messages',
	BLACKLISTED_CUSTOMERS: '/blacklisted-customers',
	USER_SETTINGS: '/my-profile',
	SECURITY_SETTINGS: '/security-settings',
	NOTIFICATION_SETTINGS: '/notification-settings',
	EMAIL: '/email',
	EMAIL_ACCOUNTS: 'email-accounts',
	EMAIL_SETTINGS: 'email-settings',
	AREA: '/area',
	AREA_SETTINGS: 'area-settings',
	CITY_GROUP: 'city-group',
	SHIPPING_PRICE: '/shipping-prices',
	SHIPPING_PRICES: 'shipping-prices',
	SPECIAL_PRICE_SETTING: 'special-price-setting',
	SHIPPING_PRICE_TRANSACTIONS: 'shipping-price-transactions',
	INVOICE_CHECKER_HISTORY: 'invoice-checker-history',
	GENERAL_SETTINGS: '/company-settings',
	LOCALIZATION_SETTINGS: '/localization-settings',
	PAYMENTS: '/payments',
	CREDIT_TRANSACTIONS: 'credit-transactions',
	SUBSCRIPTION_TRANSACTIONS: 'subscription-transactions',
	FREE_CREDIT_TRANSACTIONS: 'free-credit-transactions',
	OTO_LINK_TRANSACTIONS: 'oto-link-transactions',
	CONTRACTED_SHIPMENTS: 'contracted-shipments',
	MANAGE_SUBSCRIPTION: '/manage-subscription',
	PAYMENT_NAMAGEMENT: '/payment-management',
	PRINT_SETTINGS: '/print-settings',
	OTOAWB: '/OTOAWB',
	SMS_SETTINGS: '/sms-settings',
	SMS_PROVIDERS: '/sms-providers',
	ALL_PROVIDERS: 'providers',
	CONNECTED_PROVIDERS: 'connected-providers',
	WEBHOOKS: '/webhooks',
	CUSTOMIZABLE_PAGES: '/customizable-pages',
	SMS_ERROR: '/sms-error',
	SMS_EXPIRED: '/sms-expired',
	PDF_ERROR: '/pdf-error',
	WAREHOUSES: '/warehouses',
	WH_DASHBOARD: '/wh-dashboard',
	WH_PENDING_ORDERS: '/wh-pending-orders',
	WH_WAITING_PICKUP: '/wh-waiting-pickup',
	WH_SHIPMENT_ONHOLD: '/wh-shipment-onhold',
	WH_SHIPMENT_INPROGRESS: '/wh-shipment-inprogress',
	WH_HISTORY: '/wh-history',
	SHIPPING_AUTOMATION: '/shipping-automation',
	FEASIBILITY_RULES: 'feasibility-rules',
	PRIORITY_RULES: 'priority-rules',
	ORDER_AUTOMATION: '/order-automation',
	USERS: '/users',
	BRANCHES: '/branches',
	BR_PENDING_ORDERS: '/br-pending-orders',
	BR_WAITING_FOR_DRIVER: '/br-waiting-for-driver',
	BR_RETURNED: '/br-returned',
	BR_SHIPMENT_IN_PROGRESS: '/br-shipment-in-progress',
	BR_DASHBOARD: '/br-dashboard',
	BR_DELIVERED: '/br-delivered',
	BR_CANCELED: '/br-canceled',
	BR_UNASSINGED: '/br-unassigned',
	DR_HOME: '/dr-home',
	SHIPPING_PARTNERS: '/shipping-partners',
	CONNECTED_PARTNERS: 'connected-partners',
	MORE_CONNECTION: 'more-connection',
	SHIPPING_PARTNER_FORM: '/shipping-partners/shipping-partner-form',
	SHIPPING_PARTNER_SLA_FORM: '/shipping-partners/shipping-partner-sla-form',
	SHIPPING_PARTNER_DELIVERY_SLOT_CONFIGURATION_FORM: '/shipping-partners/delivery-slot-management',
	ORDER_INFORMATION: '/order-information',
	CITY_COVERAGE: 'shipping-partner-city-coverage',
	OTHER_INTEGRATIONS: '/other-integrations',
	OTHER_INTEGRATIONS_LIST: '/other-integrations-admin',
	INTEGRATIONS: 'integrations',
	CONNECTED_INTEGRATIONS: 'connected-integrations',
	REPORTS: '/reports',
	ORDER_REPORTS: 'order-reports',
	SHIPMENT_REPORTS: 'shipment-reports',
	OTOFLEX_REPORTS: 'otoflex-reports',
	OTHER_REPORTS: 'other-reports',
	ORDER_STATUS_LOGS: '/reports/order-reports/order-status-logs',
	SALES_BY_SKU: '/reports/order-reports/sales-by-sku',
	ORDERS_BY_PRODUCT_REPORT: '/reports/order-reports/orders-by-product-report',
	AGED_ORDERS_REPORT: '/reports/order-reports/aged-orders-report',
	RESENT_ORDERS: '/reports/order-reports/resent-orders',
	ORDER_HEATMAP: '/reports/order-reports/order-heatmap',
	CUSTOM_REPORT_1: '/reports/order-reports/custom-report-1',
	DELIVERY_COMPANY_REPORT_BY_CITY: '/reports/shipment-reports/delivery-company-report-by-city',
	SHIPMENT_STATUS_REPORT: '/reports/shipment-reports/shipment-status-report',
	FAILED_DELIVERY: '/reports/shipment-reports/failed-delivery',
	PICKUP_DELIVERY_REPORT: '/reports/shipment-reports/pickup-delivery-report',
	DELIVERY_ATTEMPT_REPORT: '/reports/shipment-reports/delivery-attempt-report',
	DELIVERED_ORDERS_BY_CITY_BY_COURIER: '/reports/shipment-reports/delivered-orders-by-city-by-courier',
	AGGREGATOR_PROFIT_REPORT: '/reports/shipment-reports/aggregator-profit-report',
	TRANSACTION_REPORT: '/reports/otoflex-report/transaction-report',
	DAILY_ORDER_STATS: '/reports/order-reports/daily-order-stats',
	DRIVER_SUMMARY: '/reports/otoflex-reports/driver-summary',
	DRIVER_DETAILS: '/reports/otoflex-reports/driver-details',
	CUSTOMER_FEEDBACKS: '/reports/other-reports/customer-feedbacks',
	TIME_STATS: '/reports/other-reports/time-stats',
	SLA_BREACHES_REPORT: '/reports/other-reports/sla-breaches-report',
	BRANCH_REPORT: '/reports/branch-reports/branch-report',
	BRANCH_DAILY_STAFF_REPORT: '/reports/branch-reports/branch-daily-staff-report',
	NOTIFICATIONS: '/notifications',
	OTO_MODULES: '/oto-modules',
	OTO_MODULES_DETAIL: '/oto-modules/:slug',
	WAREHOUSE_MODULE: '/oto-modules/warehouse-module',
	AGGREGATOR_MODULE: '/oto-modules/aggregator-shipping',
	SALES_CHANNELS_MODULE: '/oto-modules/sales-channel',
	OTO_LINK_MODULE: '/oto-modules/oto-link',
	OTO_FLEX_MODULE: '/oto-modules/oto-flex',
	MULTI_BRAND_MODULE: '/oto-modules/multi-brand',
	SMS_MODULE: '/oto-modules/sms-module',
	IMPORTS_MODULE: '/oto-modules/imports',
	EMAIL_WHATSAPP_MODULE: '/oto-modules/email-whatsapp',
	PRODUCT_MODULE: '/oto-modules/product-information',
	INVENTORY_MODULE: '/oto-modules/oto-inventory',
	BRANCH_MODULE: '/oto-modules/branch-module',
	ROLE_MODULE: '/oto-modules/customizable-role',
	CUSTOMER_SERVICE_MODULE: '/oto-modules/customer-service',
	ORDER_AUTOMATION_MODULE: '/oto-modules/order-management',
	SHIPPING_AUTOMATION_MODULE: '/oto-modules/shipping-automation',
	WAREHOUSE_MANAGEMENT_MODULE: '/oto-modules/warehouse-management-system',
	SHIPPING_ACCOUNTING_MODULE: '/oto-modules/shipping-accounting',
	INTEGRATION_LOGS: '/integration-logs',
	NOTIFICATION_LOGS: '/notification-logs',
	SYSTEM_LOGS: '/system-logs',
	UPDATE_SUCCESS_LOGS: 'update-success-logs',
	UPDATE_ERROR_LOGS: 'update-error-logs',
	AUTOMATION_SUCCESS_LOGS: 'automation-success-logs',
	AUTOMATION_ERROR_LOGS: 'automation-error-logs',
	SMS_LOGS: 'sms-logs',
	EMAIL_LOGS: 'email-logs',
	SHIPMENT_ERROR_LOGS: 'shipment-error-logs',
	INVENTORY_SYNC_LOGS: 'inventory-sync-logs',
	PRODUCT_SYNC_LOGS: 'product-sync-logs',
	WEBHOOK_ERROR_LOGS: 'webhook-error-logs',
	PICKUP_REQUEST_LOGS: 'pickup-request-logs',
	CUSTOMER_SERVICE: '/customer-service',
	RETURNS: 'returns',
	FAILED_DELIVERY_ORDERS: 'failed-delivery-orders',
	CUSTOMER_SERVICE_FEEDBACKS: 'customer-feedbacks',
	PROCESSING_ORDERS: '/processing-orders',
	HISTORY_ORDERS: '/history-orders',
	BM_ORDERS: '/bmOrders',
	WAREHOUSES_AND_BRANCHES: '/warehouses-and-branches',
	AUTOCORRECTOR: '/autocorrector',
	REFERRALS: '/referrals',
	REFERRAL_LIST: '/referral-list',
	CREATE_SHIPMENT: '/shipments/create-shipment',
	INBOUND: 'inbound',
	OTO_PACK: 'otopack',
	OTO_PACK_REPORTS: 'otopack-reports',
	STOCK_UPDATE_REPORTS: '/reports/otopack-reports/stock-update-reports',
	ORDER_BASED_TRANSACTION: '/reports/otopack-reports/order-based-transaction-reports',
	WAVE_BASED_TRANSACTION: '/reports/otopack-reports/wave-based-transaction-reports',
	PACKING_STATUS_REPORTS: '/reports/otopack-reports/packing-status-reports',
	BRANCH_REPORTS: 'branch-reports',
	OPERATIONS: '/operations',
	INBOUND_ORDERS: 'inbound-orders',
	OUTBOUND_ORDERS: 'outbound-orders',
	PUTAWAY: 'putaway',
	PACKING: 'packing',
	BINS: 'bins',
	ZONES: 'zones',
	WMS_CONFIGURATION: '/configuration',
	WMS_CONFIGURATION_USERS: 'users',
	WMS_CONFIGURATION_USER_GROUPS: 'user-groups',
	WAVES: 'waves',
	SORTING: 'sorting',
	RETURN: 'return',
	VENDORS: 'vendors',
	INVENTORY_MAIN: '/inventory',
	INVENTORY: 'inventory',
	BIN_INVENTORY: 'bin-inventory',
	GLOBAL_INVENTORY: 'global-inventory',
	BIN_TRANSACTIONS: '/reports/otopack-reports/bin-transactions',
	DAILY_STAFF: '/reports/otopack-reports/daily-staff',
	INVENTORY_TRANSACTIONS: '/reports/otopack-reports/inventory-transactions',
	PICKING_EXCEPTION_LOGS: '/reports/otopack-reports/picking-exception-logs',
	WMS: 'wms',
	BM_PRODUCTS: '/brand-manager-products',
	BM_INVENTORY: '/bm-inventory',
	INTEGRATION_FRAME: '/integration-frame',
	EXTERNAL_PRINT: '/external-print',
	WHATSAPP: '/whatsapp',
	WHATSAPP_SETTINGS: 'whatsapp-settings',
	WHATSAPP_TEMPLATES: 'whatsapp-templates',
	CLIENT_USERS: '/client-users',
	ADDRESS_MANAGEMENT: '/address-management',
	DELIVERY_COMPANIES: '/delivery-companies',
	COUNTRIES: 'countries',
	STATES: 'states',
	CITIES: 'cities',
	DISTRICTS: 'districts',
	NEIGHBORHOODS: 'neighbourhoods',
	GOVERNORATES: 'governorates',
	ROLE_TREE: '/role-tree',
	ROLE_TEMPLATES: '/role-templates',
	CONTRACT_CONFIGURATIONS: '/contract-configurations',
	PRICE_CONFIGURATIONS: '/price-configurations',
	SLA_CONFIGURATIONS: '/sla-configurations',
	INVOICE_CHECKER: '/invoice-checker',
	SHIPPING_CONTRACTS: 'shipping-contracts',
	OTO_DELIVERY_PRICES: 'oto-delivery-prices',
	SUCCESS_INSTRUCTIONS: 'success-instructions',
	SPECIAL_CONTRACT_TERMS: 'special-contract-terms',
	OTO_MARGIN: 'oto-margin',
	CITY_BASED_PRICES: 'city-based-prices',
	TIER_BASED_PRICES: 'tier-based-prices',
	WEIGHT_BASED_PRICES: 'weight-based-prices',
	WEIGHT_COUNTRY_BASED_PRICES: 'weight-country-based-prices',
	KM_BASED_PRICES: 'km-based-prices',
	KM_BASED_SLA: 'km-based-sla',
	BULLET_KM_SLA: 'bullet-km-sla',
	TIER_BASED_SLA: 'tier-based-sla',
	DISTRICT_BASED_SLA: 'district-based-sla',
	CITY_BASED_SLA: 'city-based-sla',
	COUNTRY_BASED_SLA: 'country-based-sla',
	PURCHASE_ORDERS: '/purchase-orders',
	PRICE_CALCULATOR_WEB: '/price-calculator-web',
	INVOICES: '/invoices',
	INVOICE: 'invoice',
	INVOICE_DETAILS: 'invoice-details',
	NEW_RECORDS: 'new-records',
	PRICE_NOT_FOUND_ORDERS: 'price-not-found-orders',
	NOT_INVOICED_ORDERS: 'not-inoviced-orders',
	LANGUAGE_RESOURCE_MANAGEMENT: '/language-resource-management',
	RECONCILIATION: 'reconciliation',
	CLOSED_SHIPMENTS: 'closed-shipments',
	WEIGHT_CORR_OPEN: 'weight-corr-open',
	WEIGHT_CORR_CLOSED: 'weight-corr-closed',
	COD_WALLET: '/cod-wallet',
	COD_WALLET_LIST: '/cod-wallet-list',
	PAID_COD: '/reports/shipment-reports/paid-cod',
	AUTOMATION: '/automation',
	TIME_STATS_FOR_OPERATION: '/time-stats-for-operation',
	DELIVERY_ATTEMPT_REPORT_FOR_OPERATION: '/delivery-attempt-report',
	BANK_TRANSFER: '/bank-transfer',
	OTO_LINK_FINANCE_TRANSACTIONS: '/oto-link-transactions',
	TRANSACTIONS: '/transactions',
	CLIENT_TRANSACTIONS: 'client-transactions',
	REFUND_TRANSACTIONS: 'refund-transactions',
	BANKS: '/banks',
	COD_PAYABLE: '/cod-payable',
	NEW_COD_REPORTS: 'new-cod-reports',
	APPROVED_COD_REPORTS: 'approved-cod-reports',
	COD_RECEIVABLES: '/cod-receivables',
	NEW_RECEIVABLE_REPORTS: 'new-receivable-reports',
	NO_CONFLICT: 'no-conflict',
	RECEIVED_OTO_BANK_FROM_DC: 'received-oto-bank-from-dc',
	WAITING_RECONCILATION_ORDERS: 'waiting-reconcilation-orders',
	RECONCILED_ORDERS: 'reconciled-orders',
	PICKUP_REQUESTS: '/pickup-requests',
	PICKUP_DELIVERY_REPORT_LIST: '/pickup-delivery-report',
	IMPORT_LOGS: '/import-logs',
	EXPORT_LOGS: '/export-logs',
	STORY_MANAGEMENT: '/story-management',
	BULLET_TRACKING: '/bullet-trackings',
	BULLET_TRACKING_LIST: 'bullet-tracking-list',
	DC_PICKUP_LOCATION: '/dc-pickup-location',
	CASH_DEPOSITED_REPORTS: 'cash-deposited-reports',
	COD_WALLET_TRANSACTIONS: '/cod-wallet-transactions',
	BANK_TRANSFER_FAILED: 'bank-transfer-failed',
	BANK_TRANSFER_PROCESSING: 'bank-transfer-processing',
	ALL_WITHDRAWALS: 'all-withdrawals',
	ADMIN_COUNTRIES_MANAGEMENT: '/countries-management',
	INTEGRATOR_SLA_REPORT: '/reports/shipment-reports/integrator-sla-report',
	IMPORT_ORDERS: '/imports',
	IMPORT_CALCULATOR: '/get-estimate',
	IMPORT_ORDERS_GET_ESTIMATE: '/imports/get-estimate',
	DELIVERY_COMPANY_MODULE: '/delivery-company-module',
	DELIVERY_COMPANY_SETTINGS: 'delivery-company-settings',
	DELIVERY_COMPANY_SETTINGS_PICKUP_CITIES: '/delivery-company-module/pickup-cities',
	POLYGON_COVERAGE: 'polygon-coverage',
	DC_STATUSES: 'dc-statuses',
	DC_STATUS_GROUPS: 'dc-status-groups',
	STATUS_GROUP_TRANSITIONS: 'status-group-transitions',
	DC_STATUS_MANAGEMENT: '/dc-status-management',
	DC_STATUS_MAPPING_LIST: 'dc-status-mapping-list',
	MISSING_MAPPING_STATUSES: '/missing-mapping-statuses',
	MISSING_MAPPING_STATUSES_GROUPED: 'missing-mapping-statuses-grouped',
	MISSING_MAPPING_STATUSES_DETAILED: 'missing-mapping-statuses-detailed',
	EXTRA_CREDITS: '/extra-credits',
	EXTRA_CREDITS_SMB: 'extra-credits-smb',
	EXTRA_CREDITS_ENTERPISE: 'extra-credits-enterprise',
	CREATE_SHIPMENT_ERROR_MAPPING: '/create-shipment-error-mapping',
	CREATE_SHIPMENT_ERROR_MAPPING_LIST: 'create-shipment-error-mapping-list',
	SHIPMENT_ERROR_LOGS_BY_AI: 'shipment-error-logs-by-ai',
	HOME_PAGE_ANNOUNCEMENTS_MANAGEMENT: '/home-page-announcements-management',
	SAVINGS_CALCULATOR: '/savings-calculator'
};

export const mergePaths = (...paths) => paths.map((path) => (path.startsWith('/') ? path : `/${path}`)).join('');

export default PATHS;
